import React from 'react';
import { FaGraduationCap, FaTwitter, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="relative py-12 bg-gray-50 border-t border-gray-200 grid-pattern">
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <a href="#" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-purple-800 rounded-lg flex items-center justify-center">
                <FaGraduationCap className="text-white text-xl" />
              </div>
              <span className="text-xl font-bold text-gray-900">نافس</span>
            </a>
            <p className="text-gray-600 max-w-md leading-relaxed">
              منصة تعليمية متخصصة في مراجعة الاختبارات ومساعدة الطلاب على تحقيق أفضل النتائج الأكاديمية.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-4">معلومات</h3>
            <ul className="space-y-3">
              <li>
                <a href="/privacy" className="text-purple-800 hover:text-gray-700 transition-colors duration-300 font-medium">
                  سياسة الخصوصية
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 mt-12 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © 2025 نافس. جميع الحقوق محفوظة.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-purple-800 hover:bg-gray-700 transition-all duration-300">
                <FaTwitter className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-purple-800 hover:bg-gray-700 transition-all duration-300">
                <FaFacebook className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-purple-800 hover:bg-gray-700 transition-all duration-300">
                <FaInstagram className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-purple-800 hover:bg-gray-700 transition-all duration-300">
                <FaLinkedin className="text-white" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;